import { createContext } from 'react';

/**
 * Valeur par défaut : **le consentement n'est pas appliqué**.
 *
 * C'est ce qui garantit que l'éditeur, `/preview/` et `/review/` rendent les
 * contenus tiers exactement comme avant ce chantier. Un utilisateur interne
 * authentifié n'est pas un prospect à qui l'on demande son consentement.
 *
 * Seul `/view/` monte un provider, et il l'enclenche dès le premier rendu.
 */
export const NOT_ENFORCED = {
  enforced: false,
  /** La bibliothèque a démarré : le panneau de réglages peut s'ouvrir. */
  canManage: false,
  manifest: null,
  /** Responsable de traitement et contacts du site (normalizePrivacy). */
  privacy: null,
  /**
   * Finalités acceptées. Vide par défaut, et c'est ce qui coupe le suivi de
   * lecture hors du site publié : `isServiceAllowed` répond « oui » sans
   * provider pour laisser l'éditeur rendre ses embeds, mais mesurer la lecture
   * d'un utilisateur interne n'aurait aucun sens.
   */
  acceptedCategories: [],
  isServiceAllowed: () => true,
  allowServiceOnce: () => {},
  allowCategory: () => {},
  showPreferences: () => {},
  withdraw: () => {},
};

export const ConsentContext = createContext(NOT_ENFORCED);
